export default {

    title: 'DigiMenuBox',
    homeRoute: 'player',

    i18n: {
        language: 'nl'
    }
}